export default function ($translate, MomentService) {
    return {
        KEYS: {
            EUROPE_OSLO: 'Europe/Oslo',
            EUROPE_TALLINN: 'Europe/Tallinn',
            EUROPE_RIGA: 'Europe/Riga',
            EUROPE_HELSINKI: 'Europe/Helsinki',
            EUROPE_COPENHAGEN: 'Europe/Copenhagen',
            EUROPE_STOCKHOLM: 'Europe/Stockholm',
            EUROPE_VILNIUS: 'Europe/Vilnius',
            EUROPE_LONDON: 'Europe/London',
            EUROPE_BERLIN: 'Europe/Berlin',
            EUROPE_ROME: 'Europe/Rome',
            EUROPE_MADRID: 'Europe/Madrid',
            EUROPE_PARIS: 'Europe/Paris',
            EUROPE_MOSCOW: 'Europe/Moscow',
            AMERICA_DENVER: 'America/Denver',
            AMERICA_CHICAGO: 'America/Chicago',
            AMERICA_NEW_YORK: 'America/New_York',
            AMERICA_LOS_ANGELES: 'America/Los_Angeles',
            AMERICA_YAKUTAT: 'America/Yakutat',
            AMERICA_HALIFAX: 'America/Halifax',
            AMERICA_BUENOS_AIRES: 'America/Buenos_Aires',
            PACIFIC_HONOLULU: 'Pacific/Honolulu',
            PACIFIC_AUCKLAND: 'Pacific/Auckland',
            ASIA_DUBAI: 'Asia/Dubai',
            ASIA_TOKYO: 'Asia/Tokyo',
            ASIA_BANGKOK: 'Asia/Bangkok',
            AUSTRALIA_PERTH: 'Australia/Perth',
            AUSTRALIA_SYDNEY: 'Australia/Sydney'
        },
        LABELS: {
            EUROPE_OSLO: $translate.instant('timezone.Europe/Oslo', { offset: MomentService.getTimezoneOffset('Europe/Oslo') }),
            EUROPE_TALLINN: $translate.instant('timezone.Europe/Tallinn', { offset: MomentService.getTimezoneOffset('Europe/Tallinn') }),
            EUROPE_RIGA: $translate.instant('timezone.Europe/Riga', { offset: MomentService.getTimezoneOffset('Europe/Riga') }),
            EUROPE_HELSINKI: $translate.instant('timezone.Europe/Helsinki', { offset: MomentService.getTimezoneOffset('Europe/Helsinki') }),
            EUROPE_COPENHAGEN: $translate.instant('timezone.Europe/Copenhagen', { offset: MomentService.getTimezoneOffset('Europe/Copenhagen') }),
            EUROPE_STOCKHOLM: $translate.instant('timezone.Europe/Stockholm', { offset: MomentService.getTimezoneOffset('Europe/Stockholm') }),
            EUROPE_VILNIUS: $translate.instant('timezone.Europe/Vilnius', { offset: MomentService.getTimezoneOffset('Europe/Vilnius') }),
            EUROPE_LONDON: $translate.instant('timezone.Europe/London', { offset: MomentService.getTimezoneOffset('Europe/London') }),
            EUROPE_BERLIN: $translate.instant('timezone.Europe/Berlin', { offset: MomentService.getTimezoneOffset('Europe/Berlin') }),
            EUROPE_ROME: $translate.instant('timezone.Europe/Rome', { offset: MomentService.getTimezoneOffset('Europe/Rome') }),
            EUROPE_MADRID: $translate.instant('timezone.Europe/Madrid', { offset: MomentService.getTimezoneOffset('Europe/Madrid') }),
            EUROPE_PARIS: $translate.instant('timezone.Europe/Paris', { offset: MomentService.getTimezoneOffset('Europe/Paris') }),
            EUROPE_MOSCOW: $translate.instant('timezone.Europe/Moscow', { offset: MomentService.getTimezoneOffset('Europe/Moscow') }),
            AMERICA_DENVER: $translate.instant('timezone.America/Denver', { offset: MomentService.getTimezoneOffset('America/Denver') }),
            AMERICA_CHICAGO: $translate.instant('timezone.America/Chicago', { offset: MomentService.getTimezoneOffset('America/Chicago') }),
            AMERICA_NEW_YORK: $translate.instant('timezone.America/New_York', { offset: MomentService.getTimezoneOffset('America/New_York') }),
            AMERICA_LOS_ANGELES: $translate.instant('timezone.America/Los_Angeles', { offset: MomentService.getTimezoneOffset('America/Los_Angeles') }),
            AMERICA_YAKUTAT: $translate.instant('timezone.America/Yakutat', { offset: MomentService.getTimezoneOffset('America/Yakutat') }),
            AMERICA_HALIFAX: $translate.instant('timezone.America/Halifax', { offset: MomentService.getTimezoneOffset('America/Halifax') }),
            AMERICA_BUENOS_AIRES: $translate.instant('timezone.America/Buenos_Aires', { offset: MomentService.getTimezoneOffset('America/Buenos_Aires') }),
            PACIFIC_HONOLULU: $translate.instant('timezone.Pacific/Honolulu', { offset: MomentService.getTimezoneOffset('Pacific/Honolulu') }),
            PACIFIC_AUCKLAND: $translate.instant('timezone.Pacific/Auckland', { offset: MomentService.getTimezoneOffset('Pacific/Auckland') }),
            ASIA_DUBAI: $translate.instant('timezone.Asia/Dubai', { offset: MomentService.getTimezoneOffset('Asia/Dubai') }),
            ASIA_TOKYO: $translate.instant('timezone.Asia/Tokyo', { offset: MomentService.getTimezoneOffset('Asia/Tokyo') }),
            ASIA_BANGKOK: $translate.instant('timezone.Asia/Bangkok', { offset: MomentService.getTimezoneOffset('Asia/Bangkok') }),
            AUSTRALIA_PERTH: $translate.instant('timezone.Australia/Perth', { offset: MomentService.getTimezoneOffset('Australia/Perth') }),
            AUSTRALIA_SYDNEY: $translate.instant('timezone.Australia/Sydney', { offset: MomentService.getTimezoneOffset('Australia/Sydney') })
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/timezone/index.js